import { render, staticRenderFns } from "./complaintHandlingDialog.vue?vue&type=template&id=d19b5b1c&scoped=true"
import script from "./complaintHandlingDialog.vue?vue&type=script&lang=js"
export * from "./complaintHandlingDialog.vue?vue&type=script&lang=js"
import style0 from "./complaintHandlingDialog.vue?vue&type=style&index=0&id=d19b5b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19b5b1c",
  null
  
)

export default component.exports